import styled from "styled-components";
import {
  Attribute,
  AttributeGroup,
  AttributeProperty,
  ComponentProps,
  ConfigContext,
  ConfigsProvider,
} from "react-builder";
import { useFitness } from "../../providers/FitnessV2";
import { useContext, useEffect, useState } from "react";
import { VideoCategory } from "../../providers/Videos";
import { config } from "process";

@AttributeGroup({
  title: "FitnessVideoByCategoryProviderV2",
  blockName: "FitnessVideoByCategoryProviderV2",
  module: "fitness",
  icon: "query",
})
export class FitnessVideoByCategoryProviderV2Attributes extends Attribute {
  @AttributeProperty({ type: "String" })
  category: string = "yoga";
}

const FitnessVideoByCategoryProviderV2Theme = styled.div(
  (props: { attributes: FitnessVideoByCategoryProviderV2Attributes }) => `

    ${props.attributes.toCSS()}

`
);

export function FitnessVideoByCategoryProviderV2(
  props: ComponentProps<FitnessVideoByCategoryProviderV2Attributes>
) {
  const [videoCategories, setVideoCategories] = useState<VideoCategory[]>();
  const { configs } = useContext(ConfigContext);
  const play = configs.play;
  const fitness = useFitness();

  useEffect(() => {
    if (props.attributes.category && fitness.loadVideos)
      fitness?.loadVideos(props.attributes.category).then((s) => {
        console.log(fitness.videosBySubCategory);

        // setVideoCategories(fitness.videosBySubCategory)
      });
  }, [fitness.loadVideos]);
  useEffect(() => {
    setVideoCategories(fitness.videosBySubCategory);
  }, [fitness.videosBySubCategory]);

  const playSecureVideo = async (url: string) => {
    const movieUrl = await fitness.loadSecureFile(url);
    play(movieUrl);
  };

  return (
    <ConfigsProvider
      {...props}
      configJson={{ categories: videoCategories ?? [], videos: fitness?.videos, playSecureVideo }}
    >
      <>{props.children}</>
    </ConfigsProvider>
  );
}

FitnessVideoByCategoryProviderV2.prototype.Props = FitnessVideoByCategoryProviderV2Attributes;

export default FitnessVideoByCategoryProviderV2;
